import React from 'react'
import logo from './logos/logo-caption-white.png'
function LogoWithCaptionWhite({
  className
}) {
  return (
    <div className={className}>
      <img src={logo} alt="XiViX Logo" />
    </div>
  );
  }

export default LogoWithCaptionWhite
